import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'
import Car from '../components/Cars'
import Rent from '../components/Rent'
import About from '../components/About'
import Icons from '../components/Icons'

import {Link, Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const HomeIndex = () => {
    const {t} = useTranslation();

        return (
              <Layout>

                <Helmet
                    title="HH Auto"
                    meta={[
                        { name: 'description', content: 'HH Auto - prodaja, uvoz i rent a car.' },
                        { name: 'keywords', content: 'hhauto, auto, rentacar, kupovina, prodaja automobila, rent-a-car, uvoz rabljenih vozila, hh auto travnik, iznajmljivanje vozila' },
                    ]}
                >
                </Helmet>
                
                <Banner />
                <About />

                <Icons/>
                
                <Car />
                <Rent/>

               
            </Layout>
            
        )
    }


export default HomeIndex;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;